/*@ngInject*/
const UIWatcherManagerDirective = function ($timeout, watchManagerUtil) {

    let linkFunction = function ($scope, $elm) {

        let reEnableWatchers = [];

        function configure() {

            $scope.$watch('uiWatchIsVisible', function (isVisible) {
                if (isVisible === 'true') {
                    _.each(reEnableWatchers, function (reEnableWatcher) {
                        reEnableWatcher();
                    });
                    reEnableWatchers = [];
                } else {
                    $timeout(function () {
                        clearChildScopes(angular.element($elm).scope(), false);
                    }, 0);
                }
            });

            function clearChildScopes(scope, clearScope) {
                let child = scope.$$childHead;

                if (clearScope) {
                    reEnableWatchers.push(watchManagerUtil.clearWatcherList(scope));
                }

                while (child) {
                    clearChildScopes(child, true);
                    child = child.$$nextSibling;
                }
            }

            $scope.$on('$destroy', function () {
                watchManagerUtil.reset();
            });
        }

        configure();
    };

    return {
        restrict: 'A',
        link: linkFunction,
        scope: {
            uiWatchIsVisible: '@'
        }
    };
};

angular.module('umCore')
    .directive('uiWatcherManager', UIWatcherManagerDirective);
